import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useMobileMode } from '../../hooks/useMobileMode.js';
import { style } from '../../utils/style.js';
import { Text } from '../Text/Text.js';
const badgeBgStyleMap = {
    primary: 'bg-white/30',
    secondary: 'bg-main-divider',
};
const badgeTextColorStyleMap = {
    primary: { desktop: 'text-white', mobile: 'text-primary-text' },
    secondary: { desktop: 'text-secondary-text', mobile: 'text-secondary-text' },
};
export const Badge = JSX(({ count, version = 'secondary' }) => {
    const isMobileMode = useMobileMode();
    const badgeBgStyle = isMobileMode ? 'bg-main-divider' : badgeBgStyleMap[version];
    const textStyle = badgeTextColorStyleMap[version][isMobileMode ? 'mobile' : 'desktop'];
    return (_jsx("div", { className: style('w-6 h-6 rounded-full flex items-center justify-center', badgeBgStyle), role: "status", "aria-label": `Количество ${count} доступных программ и сервисов`, children: _jsx(Text, { size: "text-xs", color: textStyle, children: count }) }));
});
//# sourceMappingURL=Badge.js.map